import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const http = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
});

http.interceptors.request.use(
  function(config) {
    const data = JSON.parse(sessionStorage.getItem('jwt') || localStorage.getItem('jwt'));
    const token = data ? data.token : '';
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    return Promise.reject(error.response);
  }
);

const HttpFacade = function httpFacade() {
  function removeEmptyProperties(obj) {
    Object.keys(obj).forEach(key => (obj[key] === undefined ? delete obj[key] : ''));
    return obj;
  }
  function buildQueryString(query = {}) {
    const cleanedQuery = removeEmptyProperties(query);
    const queryString = Object.keys(cleanedQuery)
      .map(key => key + '=' + cleanedQuery[key])
      .join('&');
    return queryString;
  }

  return {
    post: function post(options) {
      const { url, body, query } = options;
      const queryString = buildQueryString(query);
      const _url = `${API_BASE_URL}/${url}?${queryString}`;
      return http.post(_url, body).then(response => {
        return response.data;
      });
    },
    patch: function patch(options) {
      const { url, body, query } = options;
      const queryString = buildQueryString(query);
      const _url = `${API_BASE_URL}/${url}?${queryString}`;
      return http.patch(_url, body).then(response => {
        return response.data;
      });
    },

    get: function get(options) {
      const { url, query } = options;
      const queryString = buildQueryString(query);
      const _url = `${API_BASE_URL}/${url}?${queryString}`;
      return http.get(_url).then(response => response.data);
    },

    delete: function _delete(options) {
      const { url, query } = options;
      const queryString = buildQueryString(query);
      const _url = `${API_BASE_URL}/${url}?${queryString}`;
      return http.delete(_url).then(response => response.data);
    },

    put: function put(options) {
      const { url, body, query } = options;
      const queryString = buildQueryString(query);
      const _url = `${API_BASE_URL}/${url}?${queryString}`;
      return http.put(_url, body).then(response => response.data);
    }
  };
};

export default HttpFacade();
